import * as React from 'react';

import { Button, Result } from 'antd';

import { useQueryClient } from '@tanstack/react-query';
import productService from 'v2/services/product';

const FreightVinculation = () => {
  const queryClient = useQueryClient();

  const closeTab = React.useCallback(async () => {
    const params = new URL(document.location.href).searchParams;
    const melhorEnvioCode = params.get('code');
    await productService.enableMelhorEnvioAuth(melhorEnvioCode);
    queryClient.invalidateQueries({ queryKey: ['delivery-integrations'] });
    window.opener.handleCloseMelhorEnvioPopup();
    window.close();
  }, [queryClient]);

  return (
    <Result
      status='success'
      title='Vinculado com sucesso'
      subTitle='Conta vinculada ao Melhor Envio'
      extra={<Button id='new-product-melhor-envio-ok' onClick={closeTab}>Ok</Button>}
    />
  );
};

export default FreightVinculation;
